<template>
  <div class="h-100">
    <div class="match-card match-card__more-matches text-center">
      <div class="match-card__header" v-if="avatars.length">
        <div class="avatar-triple">
          <div class="avatar-triple__image" :style="{'background-image':'url(' + avatars[0] + '?h=100)'}">
          </div>
          <div class="avatar-triple__image" :style="{'background-image':'url(' + avatars[1] + '?h=200)'}">
          </div>
          <div class="avatar-triple__image" :style="{'background-image':'url(' + avatars[2] + '?h=100)'}">
          </div>
        </div>
      </div>
      <div class="match-card__desc">
        <div class="title title--large title--white">
          {{ trans.get('pages:match_game.no_more_card.header') }}
        </div>

        <div class="desc desc--white">
          {{ trans.get('pages:match_game.no_more_card.slogan') }}
        </div>
      </div>
      <div class="match-card__button">
        <router-link :to="{name: 'members', hash: '#search'}" class="button button__outline button__outline--white-hov-purple">
          {{ trans.get('pages:match_game.no_more_card.show_settings_button') }}
        </router-link>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'NoMoreCard',
  props: {
    current: Object,
  },
  data() {
    return {};
  },
  computed: {
    avatars: function () {
      return this.$store.getters['homeProfiles/getRandomAvatars'];
    }
  },
  methods: {},
  mounted() {
  }
};
</script>


